import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { TokenRegenerationService } from './_services/token-regenration.service';
import { UserAuthService } from './_services/user-auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'ltyadmin';

  constructor(
    private readonly authService: UserAuthService,
    private readonly tokenRegenerationService: TokenRegenerationService,
    private readonly router: Router
    // Uncomment if we need to cancel all HTTP calls when changing navigation
    // private readonly httpCancelService: HttpCancelService
  ) {
    authService.checkVersion();
    authService.handleTokenInit();
  }

  ngOnInit(): void {
    // Uncomment if we need to cancel all HTTP calls when changing navigation
    // this.router.events.subscribe(event => {
    //   if (event instanceof ActivationStart) {
    //     this.httpCancelService.cancelPendingRequests();
    //   }
    // });
  }
}
